"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var TabPane = _FlexTabContainer["default"].TabPane;
function PictureComponent(props) {
  var imageSrc = props.imageSrc;
  var _a = (0, _utils.fomateFileData)(imageSrc),
    url = _a.url,
    _b = _a.alt,
    alt = _b === void 0 ? '' : _b;
  var _c = (0, _react.useState)({}),
    styles = _c[0],
    setStyls = _c[1];
  // console.log(styles);
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    if (url) {
      imgLoad.src = url;
    }
    imgLoad.onload = function () {
      var collectStyles = {};
      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }
      // console.log(imgLoad.width, imgLoad.height, 'styles');
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({
      margin: '0 auto',
      maxWidth: '160px',
      maxHeight: '54px',
      width: '10px'
    }, styles),
    src: url,
    alt: alt
  });
}
var Article = function Article(props) {
  var source = props.source,
    record = props.record,
    onCallbackHandle = props.onCallbackHandle,
    className = props.className,
    hrefText = props.hrefText,
    href = props.href,
    title = props.title,
    article = props.article;
  var extendProps = (record || {}).extendProps;
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-article', className)
  }, extendProps || {}, {
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, source && ( /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '12px'
    }
  }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
    imageSrc: source
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word'
    },
    onClick: function onClick() {
      onCallbackHandle === null || onCallbackHandle === void 0 ? void 0 : onCallbackHandle(record);
    }
  }, title && /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('div-content'),
    dangerouslySetInnerHTML: {
      __html: article || ''
    }
  }), href && ( /*#__PURE__*/_react["default"].createElement("a", __assign({
    className: 'flex-default-article_a',
    href: href
  }, extendProps || {}), hrefText || "Learn more ", " >"))))));
};
var CustomerComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var style = props.style,
    flexTitle = props.flexTitle,
    configuration = props.configuration,
    onClick = props.onClick,
    restProps = __rest(props, ["style", "flexTitle", "configuration", "onClick"]);
  var _a = (0, _react.useState)(true),
    currentClass = _a[0],
    setCurrentClass = _a[1];
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'CustomersTab',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-customers-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), currentClass ? ( /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '24px 24px 0'
    }
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], __assign({
    ref: ref
  }, restProps), configuration ? configuration.map(function (item, i) {
    var _a = item,
      title = _a.title,
      key = _a.key,
      list = _a.list;
    var compatibleArr = list;
    var numLenThree = [5].includes(list.length) || list.length % 3 == 0;
    var numLenTwo = [2].includes(list.length);
    var numLenFour = [4].includes(list.length) || list.length > 6 && list.length % 3 != 0;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: title
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'CustomersTabs',
      key: i,
      style: key != 1 ? {
        display: 'none',
        paddingTop: '24px'
      } : {
        paddingTop: '24px'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-customers-article'
    }, compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.map(function (item, index) {
      var content = item.content,
        title = item.title,
        href = item.href,
        source = item.source,
        hrefText = item.hrefText;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex-default-customers-article__list', {
          'flex-default-customers-article__list--three': numLenThree,
          'flex-default-customers-article__list--four': numLenFour,
          'flex-default-customers-article__list--two': numLenTwo
        }),
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('customer-img-container', {
          'customer-img-container--hover': href && hrefText
        })
      }, /*#__PURE__*/_react["default"].createElement(Article, {
        record: item || {},
        article: content,
        title: title,
        href: href,
        hrefText: hrefText,
        source: source
      })));
    }))));
  }) : null))) : ( /*#__PURE__*/_react["default"].createElement(FlexAccordion, {
    style: style,
    configuration: configuration
  }))));
});
function FlexAccordion(props) {
  var configuration = props.configuration,
    style = props.style;
  var _a = (0, _react.useState)(1),
    saveKey = _a[0],
    setSaveKey = _a[1];
  var childrenNodes = {};
  var chilen = configuration.length;
  var getHeightVal = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (getHeightVal) {
        childrenNodes = getHeightVal.current.childNodes;
        // todo optimize
        // 12 初始状态下少12 offsetHeight
        // 24 距离底部距离
        for (var i = 0; i < childrenNodes.length; i++) {
          if (i == 0) {
            getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = "auto";
          } else {
            getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = "0";
          }
        }
      }
    }, 1000);
  }, []);
  var checkTabsStatus = function checkTabsStatus(key) {
    var _childrenNodes = getHeightVal;
    var _loop_1 = function _loop_1(i) {
      // 查询到指定要获取高度
      var transformClass = _childrenNodes.current.childNodes[i].childNodes[0];
      if (i == Number(key) - 1) {
        if (transformClass.className.indexOf('am-accordion-item-leave') > -1) {
          setTimeout(function () {
            // 24 距离底部距离
            transformClass.lastChild.style.height = 'auto';
            // debugger
            // console.log(collectHeight,transformClass.lastChild);
          });
          transformClass.className = 'am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'am-accordion-item-leave';
      }
    };
    // todo optimize
    for (var i = 0; i < _childrenNodes.current.childNodes.length; i++) {
      _loop_1(i);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'relevance-flex-scene-accordion',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion my-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration.map(function (item, i) {
    // console.log(item);
    var _a = item,
      list = _a.list,
      title = _a.title,
      // description,
      // tabTitle,
      key = _a.key;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'am-accordion-item': i == 0,
        'am-accordion-item-leave': i !== 0
      }),
      onClick: function onClick() {
        checkTabsStatus(key);
        if (key === saveKey) {
          setSaveKey(0);
        } else {
          setSaveKey(key);
        }
      },
      style: chilen == 1 ? {
        background: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-title",
      role: "button",
      "aria-expanded": "false",
      style: chilen == 1 ? {
        display: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-title__scene-tabs-h4'
    }, title), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "design-iconfont d-icon",
      fill: "#000000"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      transform: "rotate(-180 12.25 12.25)",
      d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
      fillRule: "evenodd"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-container'
    }, list.map(function (vals, keys) {
      var content = vals.content,
        title = vals.title,
        href = vals.href,
        source = vals.source,
        hrefText = vals.hrefText,
        supplement = vals.supplement;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'flex-default-customers-article',
        key: keys
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: supplement ? {
          visibility: 'hidden'
        } : {},
        className: (0, _classnames["default"])('flex-default-customers-article__list')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('customer-img-container', {
          'customer-img-container--hover': href && hrefText
        })
      }, /*#__PURE__*/_react["default"].createElement(Article, {
        record: item || {},
        article: content,
        title: title,
        href: href,
        hrefText: hrefText,
        source: source
      }))));
    }))));
  }))))));
}
CustomerComponent.displayName = 'TCICustomerComponent';
var _default = exports["default"] = CustomerComponent;